import type { LoggerService } from "@/services/abstract/LoggerService";
import { makeMessageHandler } from "@/services/poc/handlers/makeMessageHandler";

export const createFileReplicationFailedHandler = (loggerService: LoggerService) =>
  makeMessageHandler(
    'fileReplicationFailed',
    'six3ro:p2p:handlers:file-replication-failed',
    loggerService,
    (message) => ({
      type: 'fileReplicationFailed',
      data: {
        cid: message.cid,
        sixId: message.sixId,
        reason: message.reason,
        sender: message.sender,
        messageTimestamp: message.timestamp,
      },
    })
  );
